module.exports = __webpack_public_path__ + "static/media/Dave.e625afac.png";